import api from '@/api/car'

const state = {
  cars: [],
  currentCar: null,
  total: 0,
  loading: false
}

const getters = {
  allCars: state => state.cars,
  currentCar: state => state.currentCar,
  carsTotal: state => state.total,
  isLoading: state => state.loading
}

const mutations = {
  SET_CARS(state, { cars, total }) {
    state.cars = cars
    state.total = total
  },
  SET_CURRENT_CAR(state, car) {
    state.currentCar = car
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  ADD_CAR(state, car) {
    state.cars.unshift(car)
    state.total++
  },
  UPDATE_CAR(state, updatedCar) {
    const index = state.cars.findIndex(c => c._id === updatedCar._id)
    if (index !== -1) {
      state.cars.splice(index, 1, updatedCar)
    }
  },
  REMOVE_CAR(state, carId) {
    state.cars = state.cars.filter(c => c._id !== carId)
    state.total--
  }
}

const actions = {
  async fetchCars({ commit }, params) {
    commit('SET_LOADING', true)
    try {
      const response = await api.list(params)
      commit('SET_CARS', {
        cars: response.data.items,
        total: response.data.total
      })
      return response.data
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchCarById({ commit }, id) {
    commit('SET_LOADING', true)
    try {
      const response = await api.getById(id)
      commit('SET_CURRENT_CAR', response.data)
      return response.data
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createCar({ commit }, carData) {
    const response = await api.create(carData)
    commit('ADD_CAR', response.data)
    return response.data
  },

  async updateCar({ commit }, { id, data }) {
    const response = await api.update(id, data)
    commit('UPDATE_CAR', response.data)
    return response.data
  },

  async deleteCar({ commit }, id) {
    await api.delete(id)
    commit('REMOVE_CAR', id)
  },

  async toggleFeatured({ commit }, { id, featured }) {
    const response = await api.patch(id, { featured })
    commit('UPDATE_CAR', response.data)
    return response.data
  },

  async updateStatus({ commit }, { id, status }) {
    const response = await api.patch(id, { status })
    commit('UPDATE_CAR', response.data)
    return response.data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
